export default __webpack_public_path__ + "static/media/udhZ1e01.fabd079c.svg";